import React, { useState, useEffect, useContext } from "react";

import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import Button from "../../atoms/button/button";
import DefaultImage from "../../../assets/images/not-found/03-SIN-LOGO.svg";

import "./mobileCommentModal.scss";
import GlobalContext from "../../../contexts/globalContext";

interface MobileCommentModalInter {
  valueInput?: string;
  handlerInput?: (any) => void;
  imageInput?: any;
  setImageInput?: any;
  updatingComment?: any;
  replyingCommentId?: any;
  idConversation: any;
  closeModal: any;
  closeModalPublish: any;
  urlImage?: any;
}

const MobileCommentModal = (props: MobileCommentModalInter) => {
    const { gigyaContext: { gigyaAccount } } = useContext(GlobalContext);
  const { document } = useBrowserMode();
  const initialInput = props.valueInput ? props.valueInput : "";

  const [inputText, setInputText] = useState(initialInput);
  const [inputImage, setInputImage] = useState<any>(null);
  const [urlImage, setUrlImage] = useState<any>(DefaultImage);
  const [renderImage, setRenderImage] = useState<any>(null);

  useEffect(() => {
    if (typeof gigyaAccount?.profile.photoURL !== "undefined")
      setUrlImage(gigyaAccount?.profile.photoURL);
  }, [gigyaAccount?.UID]);

  const handleInputText = (e) => {
    setInputText(e.target.value);
  };

  const makeCommentHandler = async () => {
    const URL = process.env.URL_BIBLIOTECAS_SERVICES;

    if (!props.replyingCommentId && !props.valueInput) {
      try {
        const req = await fetch(
          `${URL}/community/api/v1/response?email=${gigyaAccount?.profile.email}&content=${inputText}&parent=${props.idConversation}`,
          {
            method: "POST",
          }
        );
        await req.json();
        props.closeModalPublish(true);
      } catch (err) {
        props.closeModalPublish(true);
      }
    } else if (props.valueInput) {
      try {
        let req = await fetch(
          `${URL}/community/api/v1/response?email=${gigyaAccount?.profile.email}&content=${inputText}&responseId=${props.updatingComment}`,
          {
            method: "PUT",
          }
        );
        await req.json();
        props.closeModalPublish(true);
      } catch (err) {
        props.closeModalPublish(true);
      }
    } else if (props.replyingCommentId) {
      try {
        let req = await fetch(
          `${URL}/community/api/v1/response?email=${gigyaAccount?.profile.email}&content=${inputText}&parent=${props.idConversation}&replyTo=${props.replyingCommentId}`,
          {
            method: "POST",
          }
        );
        await req.json();
        props.closeModalPublish(true);
      } catch (err) {
        props.closeModalPublish(true);
      }
    }
  };

  document.getElementById("input-desk")?.focus();
  document.getElementById("input-mobile")?.focus();

  return (
    <div className="m-mobile-comment">
      <div className="m-mobile-comment__back">
        <div className="m-mobile-comment__back__upper">
          <p className="m-mobile-comment__back__upper-title">Comentar</p>
          <p className="icon-close" onClick={props.closeModal}></p>
        </div>

        <div className="m-mobile-comment__back__profile">
          <div className="m-mobile-comment__back__profile-img">
            <img
              src={urlImage}
              alt={`Perfil ${gigyaAccount?.profile.firstName} ${gigyaAccount?.profile.lastName}`}
            />
          </div>

          <div className="m-mobile-comment__back__profile-input">
            <input
              type="text"
              value={inputText}
              onChange={handleInputText}
              placeholder="Comenta algo..."
              maxLength={300}
              id="input-desk"
            />
          </div>

          <div className="m-mobile-comment__back__profile-add">
            <input
              type="file"
              className="m-mobile-comment__back__profile-add__file"
              accept="image/*"
              onChange={(event) => {
                if (event.target.files) {
                  props.setImageInput
                    ? props.setImageInput(
                        URL.createObjectURL(event.target.files[0])
                      )
                    : setInputImage(URL.createObjectURL(event.target.files[0]));
                  setRenderImage(true);
                }
              }}
            />
            <p className="icon-camera m-mobile-comment__back__profile-add__icon"></p>
          </div>
        </div>

        <div className="m-mobile-comment__back__input">
          <textarea
            onChange={handleInputText}
            placeholder="Comenta algo..."
            maxLength={300}
            id="input-mobile"
          />

          {renderImage !== null ? (
            <div className="m-mobile-comment__back__input-img">
              <img
                src={props.imageInput || inputImage}
                alt={props.imageInput ? props.imageInput.name : inputImage.name}
              />
              <div
                className="m-mobile-comment__back__input-img__delete"
                onClick={() => {
                  setInputImage(null);
                  setRenderImage(null);
                }}
              >
                <p className="icon-trash-alt"></p>
              </div>
            </div>
          ) : null}
        </div>

        <div className="m-mobile-comment__back__btns">
          <Button
            type="button"
            isDisabled={false}
            text="CANCELAR"
            classname="m-mobile-comment__back__btns-btn1"
            onClickAction={props.closeModal}
          />

          <Button
            type="button"
            isDisabled={false}
            text="PUBLICAR"
            classname="m-mobile-comment__back__btns-btn2"
            onClickAction={makeCommentHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileCommentModal;
